import { locale, waitLocale } from 'svelte-i18n';
import type { LayoutLoad } from './$types';
import { initI18n } from '$lib/i18n/initI18n.js';

export const load = (async ({ parent }) => {
    const parentData = await parent();
    const { language } = parentData;

    initI18n(language);
    locale.set(language);

    await waitLocale();
}) satisfies LayoutLoad;
